const mockUsernames = [
  "GamingGuru", "BettingBoss", "CryptoWhale", "SportsFanatic", "CasinoQueen",
  "PokerPro", "DailyWager", "LuckyCharm", "HighStakesHarry", "SpinMaster",
  "CardShark", "OddsOracle", "BonusHunter", "JackpotJunkie", "QuickBetKyle",
  "RiskTakerRon", "StrategySam", "WinningWizard", "AceOfSpades", "GoldenGamble"
];

const mockAvatars = [
  "https://bit.ly/sage-adebayo", "https://bit.ly/kent-c-dodds", "https://bit.ly/ryan-florence",
  "https://bit.ly/code-beast", "https://bit.ly/prosper-baba", "https://bit.ly/tioluwani-kolawole",
  "https://bit.ly/dan-abramov", "https://bit.ly/broken-link"
];

const getRandomElement = (arr) => arr[Math.floor(Math.random() * arr.length)];
const getRandomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
const getRandomTimeAgo = () => {
  const minutes = getRandomNumber(1, 59);
  const hours = getRandomNumber(1, 23);
  const days = getRandomNumber(1, 7);
  const options = [`${minutes}m ago`, `${hours}h ago`, `${days}d ago`];
  return getRandomElement(options);
};

const generateComments = (count) => {
  const comments = [];
  for (let i = 0; i < count; i++) {
    comments.push({
      author: getRandomElement(mockUsernames),
      avatar: getRandomElement(mockAvatars),
      content: getRandomElement([
        "Totally agree with this!",
        "That's a solid point, never thought of it that way.",
        "I had a similar experience last week.",
        "Any tips for beginners on this topic?",
        "This is really helpful, thanks for sharing!",
        "Disagree, I think X is a better approach.",
        "Can you elaborate on that last point?",
        "Which platform do you recommend for this?",
        "Interesting perspective, I'll consider it.",
        "Thanks for the detailed explanation!"
      ]),
      timestamp: getRandomTimeAgo(),
    });
  }
  return comments;
};

let mockDiscussions = [
  {
    id: 1,
    title: "Advanced Slot Strategies: Beyond the Basics",
    content: "I've been diving deep into advanced slot strategies this year, looking for ways to gain an edge. What are your most unconventional or highly effective methods for maximizing wins and minimizing losses? Are there any hidden gems among providers or specific game mechanics you exploit?",
    author: "SpinMaster",
    avatar: "https://bit.ly/sage-adebayo",
    replies: getRandomNumber(15, 40),
    views: getRandomNumber(200, 500),
    upvotes: getRandomNumber(10, 50),
    lastActivity: getRandomTimeAgo(),
    isHot: true,
    category: "Casino",
    comments: generateComments(getRandomNumber(5, 15)),
  },
  {
    id: 2,
    title: "Champions League Final Predictions & Betting Angles",
    content: "The Champions League final is just around the corner! Let's hear your boldest predictions and sharpest betting angles. Are there any dark horses with value, or are you sticking to the established giants? Share your insights on player matchups, tactical approaches, and potential upsets!",
    author: "SportsFanatic",
    avatar: "https://bit.ly/kent-c-dodds",
    replies: getRandomNumber(30, 60),
    views: getRandomNumber(300, 700),
    upvotes: getRandomNumber(20, 70),
    lastActivity: getRandomTimeAgo(),
    isHot: true,
    category: "Sports",
    comments: generateComments(getRandomNumber(8, 20)),
  },
  {
    id: 3,
    title: "The Future of Crypto in Online Gambling: What's Next?",
    content: "With new cryptocurrencies emerging constantly, what do you foresee as the next big trend in crypto payment methods for online casinos? Are we moving towards more privacy-focused coins, or will stablecoins dominate? Discuss your preferred platforms for deposits/withdrawals and any concerns you have.",
    author: "CryptoWhale",
    avatar: "https://bit.ly/ryan-florence",
    replies: getRandomNumber(10, 30),
    views: getRandomNumber(100, 300),
    upvotes: getRandomNumber(5, 20),
    lastActivity: getRandomTimeAgo(),
    isHot: false,
    category: "General",
    comments: generateComments(getRandomNumber(3, 10)),
  },
  {
    id: 4,
    title: "Maximizing VIP Benefits: Insider Tips & Tricks",
    content: "For our esteemed VIP members, what are the most valuable, perhaps lesser-known, benefits you've leveraged? Is it worth the grind to reach higher tiers, and what kind of exclusive perks, dedicated support, or bespoke experiences can one truly expect? Share your insider tips!",
    author: "HighStakesHarry",
    avatar: "https://bit.ly/code-beast",
    replies: getRandomNumber(40, 80),
    views: getRandomNumber(400, 900),
    upvotes: getRandomNumber(30, 80),
    lastActivity: getRandomTimeAgo(),
    isHot: true,
    category: "VIP",
    comments: generateComments(getRandomNumber(10, 25)),
  },
  {
    id: 5,
    title: "Live Dealer vs. RNG: The Ultimate Showdown",
    content: "The age-old debate continues: live dealer games or traditional RNG-based games? Which do you prefer and why? Share your most memorable experiences, whether it's the thrill of a live interaction or the fairness of a certified RNG. What makes one more appealing than the other for you?",
    author: "CasinoQueen",
    avatar: "https://bit.ly/prosper-baba",
    replies: getRandomNumber(20, 50),
    views: getRandomNumber(150, 400),
    upvotes: getRandomNumber(10, 30),
    lastActivity: getRandomTimeAgo(),
    isHot: false,
    category: "Casino",
    comments: generateComments(getRandomNumber(6, 18)),
  },
  {
    id: 6,
    title: "Demystifying Sports Betting Odds: A Beginner's Guide",
    content: "I'm new to sports betting and finding the world of odds a bit overwhelming. Can seasoned bettors break down the different formats (decimal, fractional, moneyline) in simple terms? How do you quickly calculate potential payouts, and what are your go-to resources for understanding implied probability?",
    author: "DailyWager",
    avatar: "https://bit.ly/dan-abramov",
    replies: getRandomNumber(10, 30),
    views: getRandomNumber(80, 250),
    upvotes: getRandomNumber(5, 15),
    lastActivity: getRandomTimeAgo(),
    isHot: false,
    category: "Sports",
    comments: generateComments(getRandomNumber(4, 12)),
  },
  {
    id: 7,
    title: "Hidden Gems: Underrated Casino Game Releases",
    content: "Beyond the blockbusters, what are some of the latest casino game releases that you feel are truly underrated? Any hidden gems that offer unique gameplay, stunning graphics, or surprisingly good RTP? Share your reviews and recommendations for games that deserve more attention!",
    author: "GamingGuru",
    avatar: "https://bit.ly/tioluwani-kolawole",
    replies: getRandomNumber(25, 55),
    views: getRandomNumber(250, 600),
    upvotes: getRandomNumber(15, 45),
    lastActivity: getRandomTimeAgo(),
    isHot: true,
    category: "Casino",
    comments: generateComments(getRandomNumber(7, 17)),
  },
  {
    id: 8,
    title: "Mindful Gambling: Strategies for Sustainable Play",
    content: "Responsible gambling is paramount for long-term enjoyment. What personal strategies do you employ to ensure your gambling habits remain healthy, fun, and within your limits? Share your best tips for setting effective boundaries, recognizing early warning signs, and maintaining a balanced approach.",
    author: "StrategySam",
    avatar: "https://bit.ly/kent-c-dodds",
    replies: getRandomNumber(18, 40),
    views: getRandomNumber(120, 350),
    upvotes: getRandomNumber(8, 25),
    lastActivity: getRandomTimeAgo(),
    isHot: false,
    category: "General",
    comments: generateComments(getRandomNumber(5, 14)),
  },
  {
    id: 9,
    title: "Blog Discussion: The AI Revolution in Sports Betting",
    content: "Our latest blog post delves into the exciting (and sometimes controversial) role of AI in the future of online sports betting. From predictive analytics to personalized betting experiences, what innovations are you most looking forward to, and what are your concerns about AI's impact on the game?",
    author: "WagerStreetBlog",
    avatar: "https://bit.ly/ryan-florence",
    replies: getRandomNumber(12, 35),
    views: getRandomNumber(100, 300),
    upvotes: getRandomNumber(6, 20),
    lastActivity: getRandomTimeAgo(),
    isHot: false,
    category: "Blog",
    comments: generateComments(getRandomNumber(4, 11)),
  },
  {
    id: 10,
    title: "Monthly Roundup: Top 5 New Casino Games to Try Now!",
    content: "Our blog just dropped its monthly roundup of the top 5 new casino games! Have you had a chance to try any of them? Which ones are your favorites, and why? Are there any you'd recommend avoiding, or perhaps a dark horse that didn't make our list but should have?",
    author: "WagerStreetBlog",
    avatar: "https://bit.ly/sage-adebayo",
    replies: getRandomNumber(8, 25),
    views: getRandomNumber(70, 200),
    upvotes: getRandomNumber(3, 10),
    lastActivity: getRandomTimeAgo(),
    isHot: false,
    category: "Blog",
    comments: generateComments(getRandomNumber(2, 8)),
  },
  {
    id: 11,
    title: "E-sports Betting: New Opportunities and Challenges",
    content: "E-sports betting is growing rapidly! What are your thoughts on this new frontier? Any specific games or tournaments you follow? Discuss strategies, favorite teams, and the unique challenges of betting on competitive gaming.",
    author: "GamingGuru",
    avatar: "https://bit.ly/code-beast",
    replies: getRandomNumber(10, 30),
    views: getRandomNumber(100, 300),
    upvotes: getRandomNumber(5, 20),
    lastActivity: getRandomTimeAgo(),
    isHot: false,
    category: "Sports",
    comments: generateComments(getRandomNumber(3, 10)),
  },
  {
    id: 12,
    title: "Roulette Systems: Do They Actually Work?",
    content: "Martingale, D'Alembert, Fibonacci... there are countless roulette systems out there. Have you had any success with them, or are they just a myth? Share your experiences, both good and bad, and discuss whether any system can truly beat the house.",
    author: "LuckyCharm",
    avatar: "https://bit.ly/prosper-baba",
    replies: getRandomNumber(20, 45),
    views: getRandomNumber(180, 450),
    upvotes: getRandomNumber(10, 35),
    lastActivity: getRandomTimeAgo(),
    isHot: true,
    category: "Casino",
    comments: generateComments(getRandomNumber(6, 16)),
  },
  {
    id: 13,
    title: "Responsible Gambling Tools: What's Most Effective?",
    content: "Many platforms offer responsible gambling tools like deposit limits, self-exclusion, and reality checks. Which of these tools have you found most effective in managing your play, and what other features would you like to see implemented to promote safer gambling?",
    author: "MindfulGambler",
    avatar: "https://bit.ly/dan-abramov",
    replies: getRandomNumber(15, 35),
    views: getRandomNumber(100, 280),
    upvotes: getRandomNumber(7, 22),
    lastActivity: getRandomTimeAgo(),
    isHot: false,
    category: "General",
    comments: generateComments(getRandomNumber(4, 10)),
  },
  {
    id: 14,
    title: "The Rise of Provably Fair Games: A Game Changer?",
    content: "Provably fair games are gaining traction in the crypto casino space. Do you think this technology is a true game-changer for transparency and trust, or is it just a niche feature? Share your thoughts on its impact and your favorite provably fair titles.",
    author: "CryptoWhale",
    avatar: "https://bit.ly/ryan-florence",
    replies: getRandomNumber(10, 25),
    views: getRandomNumber(90, 270),
    upvotes: getRandomNumber(5, 18),
    lastActivity: getRandomTimeAgo(),
    isHot: false,
    category: "General",
    comments: generateComments(getRandomNumber(3, 9)),
  },
  {
    id: 15,
    title: "Best Practices for Bankroll Management in Betting",
    content: "Effective bankroll management is crucial for any serious bettor. What are your golden rules for managing your funds, setting unit sizes, and avoiding tilt? Share your strategies for preserving your bankroll and maximizing long-term profitability.",
    author: "BettingBoss",
    avatar: "https://bit.ly/kent-c-dodds",
    replies: getRandomNumber(25, 50),
    views: getRandomNumber(200, 550),
    upvotes: getRandomNumber(15, 40),
    lastActivity: getRandomTimeAgo(),
    isHot: true,
    category: "Sports",
    comments: generateComments(getRandomNumber(7, 15)),
  },
];

const mockLeaderboard = [
  { name: "MladenS", score: 1250, avatar: "https://bit.ly/sage-adebayo" },
  { name: "AlexanderG", score: 1150, avatar: "https://bit.ly/kent-c-dodds" },
  { name: "CapitalLetterM", score: 1050, avatar: "https://bit.ly/ryan-florence" },
  { name: "BettingKing2025", score: 980, avatar: "https://bit.ly/code-beast" },
  { name: "CasinoExpert", score: 920, avatar: "https://bit.ly/prosper-baba" },
  { name: "SportsNewbie", score: 870, avatar: "https://bit.ly/dan-abramov" },
  { name: "GameReviewer", score: 810, avatar: "https://bit.ly/tioluwani-kolawole" },
  { name: "ResponsiblePlayer", score: 750, avatar: "https://bit.ly/kent-c-dodds" },
  { name: "GamingGuru", score: 720, avatar: "https://bit.ly/code-beast" },
  { name: "BettingBoss", score: 680, avatar: "https://bit.ly/kent-c-dodds" },
];

const mockPromotions = [
  { title: "🎰 Casino Bonus", description: "200% up to $2000", color: "purple" },
  { title: "⚽ Sports Boost", description: "Free bet up to $100", color: "green" },
];

let mockActiveUsers = 1247;
let mockTotalPosts = 28934;
let nextDiscussionId = mockDiscussions.length + 1;

const simulateNetworkDelay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const fetchDiscussions = async (category = "All") => {
  await simulateNetworkDelay(500);
  if (category === "All") {
    return mockDiscussions;
  }
  return mockDiscussions.filter((d) => d.category === category);
};

export const fetchLeaderboard = async () => {
  await simulateNetworkDelay(300);
  return mockLeaderboard;
};

export const fetchPromotions = async () => {
  await simulateNetworkDelay(300);
  return mockPromotions;
};

export const fetchCommunityStats = async () => {
  await simulateNetworkDelay(400);
  return {
    activeUsers: mockActiveUsers,
    totalPosts: mockTotalPosts,
    expertMembers: 156,
  };
};

export const createNewDiscussion = async (newDiscussion) => {
  await simulateNetworkDelay(700);
  const discussionWithId = {
    id: nextDiscussionId++,
    ...newDiscussion,
    replies: 0,
    views: 0,
    upvotes: 0,
    lastActivity: "just now",
    isHot: false, // New discussions are not hot by default
    comments: [],
  };
  mockDiscussions.unshift(discussionWithId); // Add to the beginning
  mockTotalPosts++;
  return discussionWithId;
};

export const fetchDiscussionComments = async (discussionId) => {
  await simulateNetworkDelay(400);
  const discussion = mockDiscussions.find((d) => d.id === discussionId);
  return discussion ? discussion.comments : [];
};

export const addCommentToDiscussion = async (discussionId, comment) => {
  await simulateNetworkDelay(500);
  const discussion = mockDiscussions.find((d) => d.id === discussionId);
  if (discussion) {
    const newComment = {
      author: getRandomElement(mockUsernames), // Use random username
      avatar: getRandomElement(mockAvatars), // Use random avatar
      timestamp: "just now",
      ...comment,
    };
    discussion.comments.push(newComment);
    return { success: true, newComment };
  }
  return { success: false, message: "Discussion not found" };
};

export const voteOnDiscussion = async (discussionId, voteType) => {
  await simulateNetworkDelay(200);
  const discussion = mockDiscussions.find((d) => d.id === discussionId);
  if (discussion) {
    if (voteType === "up") {
      discussion.upvotes++;
    } else if (voteType === "down") {
      discussion.upvotes--;
    }
    return { success: true, newUpvotes: discussion.upvotes };
  }
  return { success: false, message: "Discussion not found" };
};

// Simulate real-time updates for active users and total posts
setInterval(() => {
  mockActiveUsers += Math.floor(Math.random() * 3);
  mockTotalPosts += Math.floor(Math.random() * 2);
}, 5000);